import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const endpoint = () => `${apiUtils.getBaseUri()}/`;
const getAviableNotificationType = () => 'BACK_IN_STOCK';
const setNotificationType = notificationType => `notificationType=${notificationType}`;

const loadNotifyMeList = async () => {
    const uri = `${endpoint()}users/current/productinterests?${setNotificationType(
        getAviableNotificationType(),
    )}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load notify me list (${response.status})`);
    }
    return await response.json();
};

const addToNotifyMeList = async productCode => {
    const uri = `${endpoint()}users/current/productinterests?productCode=${productCode}&${setNotificationType(
        getAviableNotificationType(),
    )}`;
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to add to notify me list (${response.status})`);
    }
};

const removeFromNotifyMeList = async productCode => {
    const uri = `${endpoint()}users/current/productinterests?productCode=${productCode}&${setNotificationType(
        getAviableNotificationType(),
    )}`;
    const response = await HTTPClient().delete(uri);

    if (!response.ok) {
        throw new Error(`Unable to remove from notify me list (${response.status})`);
    }
};

const updateNotificationPreferences = async () => {
    const uri = `${endpoint()}users/current/notificationpreferences`;
    const NotificationPreferencesDTO = {
        preferences: [
            {
                channel: 'email',
                enabled: true,
            },
        ],
    };
    const response = await HTTPClient().patchJson(uri, NotificationPreferencesDTO);
    if (!response.ok) {
        throw new Error(
            `Unable to update notification preferences email channel: (${response.status})`,
        );
    }
};

export default {
    loadNotifyMeList,
    addToNotifyMeList,
    removeFromNotifyMeList,
    updateNotificationPreferences,
};
